import React from "react";
import { Modal } from "react-bootstrap";
import Header from "../../components/Header";
const LeagalDisclaimerPopup = ({
  practitioner,
  student,
  patient,
  closePopup,
  handleAgree,
  handleExternalChange,
}) => {
  return (
    <Modal size="xl" show={true} id="disclaimer-modal">
      <Modal.Body className="disclaimer-popup">
        {/* <Header /> */}
        <div className="content-wrapper">
          <div className="content-section">
            <h3 className="disclaimer-heading">Legal Disclaimers</h3>
            {practitioner && (
              <>
                <h4>Disclaimer for Practitioners</h4>
                <p className="page-desc">
                  The software used herein and any and all information provided
                  by this software is for educational and informational purposes
                  only. This site and the information provided by our software
                  is to be used as a reference ONLY and should not be relied
                  upon when providing medical advice.
                </p>
                <p className="page-desc">
                  You should not use the information provided herein in lieu of
                  an office visit, an office call consultation, or the advice of
                  your physician or healthcare provider. Sun Ten is not
                  accepting any liability for any advice, course of treatment,
                  diagnosis or any other information, services or product you
                  obtain through this site. Medical information changes
                  frequently. Therefore, the information on this website or on
                  the linked websites should not be considered current, complete
                  or exhaustive, nor should you rely on such information to
                  recommend a course of treatment for you or any other
                  individual. Reliance on any information provided on this
                  website or any linked websites is solely at your own risk.
                </p>
                <p className="page-desc">
                  The information on this website has not been vetted or
                  approved by the FDA. The information provided is not intended
                  to diagnose, treat, cure or prevent any disease. If your
                  patient is pregnant, nursing, taking medication, or has a
                  medical condition, you must advise that they consult with
                  their physician before taking any dietary supplement.
                </p>
                <p className="page-desc">
                  It is the practitioner's responsibility to research and review
                  all herbs, formulas, and dosages based on the practitioner’s
                  assessment of their patient. Sun Ten does not assume any
                  responsibility for the recommendation and administration of
                  herbs to patients by registered practitioners. The information
                  provided by this site is a collection of information from
                  various Chinese and Western texts, case studies collected from
                  courses at Pacific College of Oriental Medicine, and various
                  seminars and clinical experience of our team from over the
                  Last 25+ years.
                </p>
                <p className="page-desc">
                  Sun Ten does not recommend or endorse any specific tests,
                  products, procedures, opinions or other information that may
                  be provided on the linked websites.
                </p>
              </>
            )}
            {student && (
              <>
                <h4>Disclaimer for Students</h4>
                <p className="page-desc">
                  The software used herein and any and all information provided
                  by this software is for educational and informational purposes
                  only. This site and the information provided by our software
                  is to be used as a reference ONLY and should not be relied
                  upon when providing medical advice.
                </p>
                <p className="page-desc">
                  You should not use the information provided herein in lieu of
                  an office visit, an office call consultation, or the advice of
                  your physician or healthcare provider. Sun Ten is not
                  accepting any liability for any advice, course of treatment,
                  diagnosis or any other information, services or product you
                  obtain through this site. Medical information changes
                  frequently. Therefore, the information on this website or on
                  the linked websites should not be considered current, complete
                  or exhaustive, nor should you rely on such information to
                  recommend a course of treatment for you or any other
                  individual. Reliance on any information provided on this
                  website or any linked websites is solely at your own risk.
                </p>
                <p className="page-desc">
                  The information on this website has not been vetted or
                  approved by the FDA. The information provided is not intended
                  to diagnose, treat, cure or prevent any disease. If your
                  patient is pregnant, nursing, taking medication, or has a
                  medical condition, you must advise that they consult with
                  their physician before taking any dietary supplement.
                </p>
                <p className="page-desc">
                  It is the student's responsibility to research and review all
                  herbs, formulas, and dosages based on the student’s assessment
                  of their patient. Sun Ten does not assume any responsibility
                  for the recommendation and administration of herbs to patients
                  by registered student's. The information provided by this site
                  is a collection of information from various Chinese and
                  Western texts, case studies collected from courses at Pacific
                  College of Oriental Medicine, and various seminars and
                  clinical experience of our team from over the Last 25+ years.
                </p>
                <p className="page-desc">
                  Sun Ten does not recommend or endorse any specific tests,
                  products, procedures, opinions or other information that may
                  be provided on the linked websites.
                </p>
              </>
            )}
            {patient && (
              <>
                <h4>Disclaimer for Patients</h4>
                <p className="page-desc">
                  The information on this website has not been vetted or
                  approved by the FDA. The information provided is not intended
                  to diagnose, treat, cure, or prevent any disease. If you are
                  pregnant, nursing, taking medication, or have a medical
                  condition, consult with your physician before taking any
                  dietary supplement.
                </p>
                <p className="page-desc">
                  IF YOU BELIEVE YOU HAVE A MEDICAL EMERGENCY, YOU SHOULD
                  IMMEDIATELY CALL 911 OR YOUR PHYSICIAN. If you believe you
                  have any other health problem, or if you have any questions
                  regarding your health or a medical condition, you should
                  promptly consult your physician or other healthcare provider.
                  Never disregard medical or professional advice, or delay
                  seeking it, because of something you read on this site or a
                  linked website.
                </p>
                <p className="page-desc">
                  Do not rely on information on this website in place of seeking
                  professional medical advice. You should talk to your physician
                  or other healthcare provider to assist you in interpreting any
                  information found on this website or in the linked websites,
                  or in applying the information to your individual case.
                </p>
                <p className="page-desc">
                  It is your practitioner's responsibility to research and
                  review all herbs, formulas, and dosages based on the
                  practitioner’s assessment of their patient. Sun Ten does not
                  assume any responsibility for the recommendation and
                  administration of herbs to patients by registered
                  practitioners.
                </p>
                <p className="page-desc">
                  The information provided by this site is a collection of
                  information from various Chinese and Western texts, case
                  studies collected from courses at Pacific College of Oriental
                  Medicine, and various seminars and clinical experience of our
                  team from over the Last 25+ years.
                </p>
                <p className="page-desc">
                  Sun Ten does not recommend or endorse any specific tests,
                  products, procedures, opinions or other information that may
                  be provided on the linked websites.
                </p>
              </>
            )}
          </div>

          <div className="button-section">
            <button
              onClick={() => {
                handleAgree(true);
                closePopup();
                handleExternalChange(true);
              }}
            >
              Agree
            </button>
            <div>|</div>
            <button
              onClick={() => {
                handleAgree(false);
                closePopup();
                handleExternalChange(false);
              }}
            >
              Disagree
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LeagalDisclaimerPopup;
